import { isInEmbeddedMode } from './utils';

const sendMessage = <T>(params: { type: string; payload?: T }): void => {
  isInEmbeddedMode() && window.ReactNativeWebView.postMessage(JSON.stringify(params));
};

export default sendMessage;
